// extracted by mini-css-extract-plugin
export default {"language":"LanguageSelector_language__HFGPU","language_img":"LanguageSelector_language_img__d1yyP","language_name":"LanguageSelector_language_name__7On5E"};